import { __assign } from "tslib";
import { connect } from 'react-redux';
import NavigationGrid from '../components/NavigationGrid';
import { showScreen, hideGrid } from '../actionCreators';
import { getScreenGroups, getFrame, getOrientation } from '../selectors';
function mapStateToProps(state) {
    return __assign(__assign({ projectName: state.project.config.name, currentScreenID: state.screen.currentScreen && state.screen.currentScreen.id }, getScreenGroups(state)), { frame: getFrame(state), orientation: getOrientation(state) });
}
function mapDispatchToProps(dispatch) {
    return {
        onSelect: function (screenID) {
            dispatch(showScreen(screenID));
        },
        onClose: function () {
            dispatch(hideGrid());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(NavigationGrid);
